import { render, staticRenderFns } from "./Request.vue?vue&type=template&id=84ee5c68&scoped=true"
import script from "./Request.vue?vue&type=script&lang=ts"
export * from "./Request.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ee5c68",
  null
  
)

export default component.exports